import cn from 'classnames';
import React, { FC, memo } from 'react';

import { Avatar } from '@mui/material';

import { getTokenIconUrl } from '@utils/logo.utils';

import { TokenSize } from '@constants/common/ui.constants';

import { TokenIconItem } from '@app-types/common/token.types';

import useStyles from './styles.module';

interface Props extends TokenIconItem {
  className?: string;
  size?: TokenSize;
}

const TokenIcon: FC<Props> = ({
  chainId,
  address,
  size = TokenSize.Large,
  className = '',
}) => {
  const { classes } = useStyles({ size });

  return (
    <Avatar
      src={getTokenIconUrl({ chainId, address })}
      className={cn(classes.avatar, className)}
    />
  );
};

export default memo(TokenIcon);
